import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" {...props}><path d="M500 10C229.3 10 10 229.3 10 500s219.3 490 490 490 490-219.3 490-490S770.5 10 500 10zM388.8 743.6l-42.7-42.7-179.8-179.6 42.7-42.7 179.8 179.8L791 256.2l42.7 42.7-444.9 444.7z" /></svg>);